module.exports = __webpack_public_path__ + "static/media/blockchain.8f54caf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/partners/blockchain.png
// module id = 259
// module chunks = 0